module.exports = __webpack_public_path__ + "img/79.347d31ef.jpg";